import {computed} from 'vue';

export enum AppCountry {
    FR = 'FR',
    AT = 'AT',
    BE = 'BE',
    CH = 'CH',
    DE = 'DE',
    DN = 'DN',
    ES = 'ES',
    IT = 'IT',
    LUX = 'LUX',
    NL = 'NL',
    PL = 'PL',
    EN = 'EN',
}

export enum AppLanguage {
    FR = 'fr',
    AT = 'at',
    BE = 'be',
    CH = 'ch',
    DE = 'de',
    DN = 'dn',
    ES = 'es',
    IT = 'it',
    LUX = 'lux',
    NL = 'nl',
    PL = 'pl',
    EN = 'en',
}

export interface UserLanguageSelection {
    name: AppLanguage | AppCountry;
    title: string;
    icon: string;
}

export function useLanguages() {
    const availableCountries = computed<UserLanguageSelection[]>(() => {
        return [
            {
                name: AppCountry.EN,
                icon: 'languages/ic_flag_uk',
                title: 'United Kingdom',
            },
            {
                name: AppCountry.FR,
                icon: 'languages/ic_flag_fr',
                title: 'France',
            },
            {
                name: AppCountry.BE,
                icon: 'languages/ic_flag_be',
                title: 'Belgium',
            },
            {
                name: AppCountry.DE,
                icon: 'languages/ic_flag_de',
                title: 'Germany',
            },
            {
                name: AppCountry.ES,
                icon: 'languages/ic_flag_es',
                title: 'Spain',
            },
            {
                name: AppCountry.IT,
                icon: 'languages/ic_flag_it',
                title: 'Italy',
            },
            {
                name: AppCountry.LUX,
                icon: 'languages/ic_flag_lux',
                title: 'Luxembourg',
            },
            {
                name: AppCountry.NL,
                icon: 'languages/ic_flag_nl',
                title: 'Nederlands',
            },
            {
                name: AppCountry.PL,
                icon: 'languages/ic_flag_pl',
                title: 'Poland',
            },
            {
                name: AppCountry.CH,
                icon: 'languages/ic_flag_ch',
                title: 'Switzerland',
            },
        ];
    });

    const availableLanguages = computed<UserLanguageSelection[]>(() => {
        return [
            {
                name: AppLanguage.EN,
                icon: 'languages/ic_flag_uk',
                title: 'English',
            },
            {
                name: AppLanguage.FR,
                icon: 'languages/ic_flag_fr',
                title: 'French',
            },
            {
                name: AppLanguage.DE,
                icon: 'languages/ic_flag_de',
                title: 'Germany',
            },
            {
                name: AppLanguage.ES,
                icon: 'languages/ic_flag_es',
                title: 'Spain',
            },
            {
                name: AppLanguage.IT,
                icon: 'languages/ic_flag_it',
                title: 'Italy',
            },
            {
                name: AppLanguage.NL,
                icon: 'languages/ic_flag_nl',
                title: 'Nederlands',
            },
        ];
    });
    return {
        availableLanguages,
        availableCountries,
    };
}
